import React from 'react';

function PrivacyPolicy() {
    return (
        <div className="privacy-policy-page container">
            <section className="mw5 mw7-ns pa3 ph5-ns">
                <h1>Privacy Policy</h1>
            </section>

            <section>
                <p>We do not store any personal information or data.</p>
            </section>

        </div>
    );
}

export default PrivacyPolicy;